import React, { ReactNode } from 'react';

export interface CommandBarProps {
  title: string;
  search?: ReactNode;
  actions?: ReactNode;
}

/**
 * The 48px line every list page shares: title at left, search centred,
 * primary action at right. Nothing page-specific goes here so it never wraps
 * on a desktop; the status facet and filters live in the FilterBar beneath.
 */
const CommandBar: React.FC<CommandBarProps> = ({ title, search, actions }) => (
  <header className="command-bar">
    <h1 className="command-bar__title">{title}</h1>
    {search && <div className="command-bar__search">{search}</div>}
    {actions && <div className="command-bar__actions">{actions}</div>}
  </header>
);

export default CommandBar;
